import React from 'react';

import { observer } from 'mobx-react';
import { Navigate, useLocation } from 'react-router-dom';

import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

import Risks from './Risks';

const RisksIndex: React.FunctionComponent = observer((): React.ReactElement => {
  const { session } = useStore();
  const { search, hash } = useLocation();

  if (session.user?.risksAssessmentsModuleEnabled) {
    return <Navigate replace to={{ pathname: routes.dashboard.risks.riskRegister, search, hash }} />;
  }

  return <Risks />;
});

export default RisksIndex;
